import React, { useContext } from 'react';
import { WindowSizeContext } from '../../../../common/context/WindowSizeContext';
import ConditionalSelectComponent from '../../../../common/components/ConditionalSelectComponent';
import { Box } from '@mui/material';
import LoadingComponent from '../../../../common/components/LoadingComponent';

export default function ArticleTypeFilter({ filters, onFilterChange, isLoading }) {
    const windowSize = useContext(WindowSizeContext);

    const availableOptions = [
        { value: ['ZTRA', 'ZTRS'], label: 'All' },
        { value: 'ZTRA', label: 'Outright' },
        { value: 'ZTRS', label: 'Consignment' }
    ]

    if (isLoading) {
        return <Box md={2} sx={{ marginY: -1, paddingX: 2, display: 'flex', justifyContent: 'end', width: "100%" }} >
            <LoadingComponent />
        </Box>
    }


    return (
        <>
            <ConditionalSelectComponent
                id="article_type_filter"
                labelId="article_type_filter-label"
                options={availableOptions}
                label={"Article Type"}
                value={
                    availableOptions.find(option => {
                        if (Array.isArray(option.value)) {
                            return Array.isArray(filters?.article_type) &&
                                option.value.every(v => filters.article_type.includes(v));
                        }
                        return option.value === filters?.article_type;
                    }) || null
                }
                onSelectChange={(event, newValue) => {
                    windowSize.isOnMobile ? onFilterChange(event.target.value, 'article_type')
                        : onFilterChange(newValue?.value, 'article_type')
                }}
                endAdornment={false}
                disableClearable={true}
            />
        </>
    )
}